import styled from 'styled-components';

export const SectionBoxStyled = styled.div`
  width: 100%;
  padding-left: ${(props) => (props?.isGlobalCarousel ? '8px' : '24px')};
  padding-right: ${(props) => (props?.isGlobalCarousel ? '16px' : '24px')};
  position: relative;
  z-index: ${(props) => (props?.isGlobalCarousel ? '0' : '1')};
  background: ${(props) => props.theme.sectionBox.bodyBg};
  border-radius: ${(props) => props.bgColor? '0px' : '8px'};

  .container {
    padding: 0;
    background: ${(props) => props.bgColor };
    border-radius: ${(props) => props.bgColor ? '8px' : '0px'};

    &.bottom-rounded-8 {
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
    }

    &::before {
      content: '';
      width: 100%;
      height: 50px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -2; 
    }

    &.whiteBg {
      background:  ${(props) => props.bgColor || props.theme.color.white};

      &::before {
        background:${(props) => props.bgColor || `linear-gradient(180deg, ${(props) => props.theme.sectionBox.gradientStart} 0, ${(props) => props.theme.color.white} 50px)}`};
      }
      &.noGradient {
        &::before {
          background: ${(props) => props.theme.color.white};
        }
      }
    }
    &.noBg{
      backgroung: none;
    }

    &.epharmacyGreen {
      &::before {
        background: ${(props) => props.theme.green.off};
      }
    }

    .titleBar {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .rightTop {
      text-align: right;
      margin-bottom: 8px;
    }

    &.ePharmacy {
      .link {
        color: ${(props) => props.theme.green.dark};

        &:hover {
          color: ${(props) => props.theme.green.light};
        }
      }
    }

    .title {
      font-size: 18px;
      font-weight: 700;
      line-height: 23px;
      margin: 30px 0 20px;
      display: inline-flex;
      align-items: center;
      margin-left: 8px;

      .subText {
        color: ${(props) => props?.theme?.clinic?.type};
        margin-left: 8px;
        font-size: 13px;
        font-weight: 600;
      }
    }

    .link {
      color: ${(props) => props.theme.blue.dark};
      font-size: 15px;
      font-weight: 700;
      margin: 20px 0;
      text-decoration: none;

      &:hover {
        color: ${(props) => props.theme.blue.light};
      }
    }
  }

  &.whiteBg {
    background: ${(props) =>  props.bgColor || props.theme.color.white};

    .container {
      &::before {
        background: ${(props) =>  !props.bgColor && `linear-gradient(
        180deg,
        ${props.theme.sectionBox.gradientStart} 0,
        ${props.theme.color.white} 50px
      )`};
      }
    }
  }

  @media (max-width: 820px) {
    padding: 16px;

    .titleBar {
      .title {
        margin: 0 0 20px 0;
      }
      .link {
        margin: 0 0 20px 0;
      }
    }
    .rightTop {
    margin-bottom: 24px;
    }
  }

  @media (max-width: 767px) {
    .px-xs-0 {
      padding-right: 0 !important;
      padding-left: 0 !important;
    }
  }

  @media (max-width: 480px) {
    .titleBar {
      .title {
        margin-left: 0;
      }
      .link {
        margin: 0 0 20px 0 !important;
        white-space: nowrap;
      }
    }
  }
`;
